(function() {
  var $8c877d5b22bb2c5e$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("load-more")) customElements.define("load-more", class LoadMore extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector("a");
        this.buttonText = this.button?.textContent;
        this.section = this.dataset.section || "";
        this.selectors = [ "[data-grid]" ];
        this.per_page = this.dataset.perPage || null;
        window.addEventListener("popstate", this.scrollUp.bind(this));
      }
      connectedCallback() {
        this.button?.addEventListener("click", this.loadMore.bind(this));
      }
      loadMore(event) {
        event.preventDefault();
        event.stopPropagation();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "select_content",
          content_type: "navigation",
          content_id: "plp-load-more",
          link_text: this.buttonText ? this.buttonText.trim() : null,
          link_url: event.target.href,
          page_section: "plp",
          page_type: document.body.getAttribute("data-template") || null
        });
        document.dispatchEvent(new CustomEvent("spinner:show", {
          detail: {
            source: "load-more"
          }
        }));
        this.classList.add("opacity-50", "cursor-wait");
        if (window.MBF?.strings?.general?.loading) this.button.textContent = window.MBF.strings.general.loading;
        const method = event.target.dataset.mode?.includes("prev") ? "afterbegin" : "beforeend";
        const container = document.querySelector(`#shopify-section-${this.section}`) || document;
        const url = new URL(event.target.href);
        const searchParams = new URLSearchParams(url.search);
        searchParams.set("section_id", this.section);
        fetch(`${url.pathname}?${searchParams.toString()}`).then(response => response.text()).then(text => {
          const html = (new DOMParser).parseFromString(text, "text/html");
          [ `[data-load-${event.target.dataset.mode || "next"}]`, ...this.selectors ].forEach(selector => {
            const oldEl = container.querySelector(selector);
            if (oldEl) {
              const newEl = html.querySelector(selector);
              if (newEl) selector.toLowerCase().includes("grid") ? oldEl.insertAdjacentHTML(method, newEl.innerHTML) : oldEl.innerHTML = newEl.innerHTML; else oldEl.parentNode.removeChild(oldEl);
            }
            history.pushState(Object.fromEntries(searchParams), "", event.target.href);
            this.button.textContent = this.buttonText;
          });
        }).catch(error => {
          console.warn(error);
          location.href = event.target.href;
        }).finally(() => {
          document.dispatchEvent(new CustomEvent("spinner:hide", {
            detail: {
              source: "load-more"
            }
          }));
          this.classList.remove("opacity-50", "cursor-wait");
        });
      }
      scrollUp() {
        if (!this.selectors.length || !this.per_page) return;
        const searchParams = new URLSearchParams(window.location.search);
        const page = parseInt(searchParams.get("page")) || 1;
        const firstElement = document.querySelector(this.selectors[0]).children[(page - 1) * this.per_page] || false;
        if (firstElement) firstElement.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  })();
})();